import { Flex } from '@mantine/core';
import { LineChartLegendItem } from '../../components/line-chart/line-chart-legend-item';

interface Props {
  selectionNames: Record<string, string>;
  selectionColors: Record<string, string>;
  hoveredItem: string | null;
  setHoveredItem: (id: string | null) => void;
}

export const FocusChartLegend = ({ selectionNames, selectionColors, hoveredItem, setHoveredItem }: Props) => {
  return (
    <Flex justify="center" align="center" gap="md" h="100%">
      {Object.entries(selectionNames).map(([itemId, itemName]) => {
        const isHovered = hoveredItem === null || hoveredItem === itemId;

        return (
          <LineChartLegendItem
            key={itemId}
            value={itemId}
            label={itemName}
            color={selectionColors[itemId]}
            isHovered={isHovered}
            onMouseEnter={setHoveredItem}
            onMouseLeave={() => setHoveredItem(null)}
          />
        );
      })}
    </Flex>
  );
};
